import LoadingV2 from '@/components/common/LoadingV2'
import { debounce } from '@/assets/js/util'

/* 底部加载通用方法
 * 在vue中引入该mixins
 * 模板中添加对应html
 * 在watch监听atBottom的，添加相应回调
 * 在获得列表数据后调用'addItem'和rollingLoad
 * e.g. '@/bianla/medicalcard-list'
 */
export const toBottomLoadMixin = {
  data () {
    return {
      atBottom: false, // 页面到达底部
      showLoadingV2: false,
      scrollTop: 0,
      rollUp: true
    }
  },
  methods: {
    // 添加项目，传入原数组, 展示数组 和添加的数目
    addItem ({ list = [], showList = [], number = 10 }) {
      let num = list.length >= number ? number : list.length
      let arr = list.splice(0, num)
      let showArr = []
      showArr = showList.concat(arr)
      this.showLoadingV2 = list.length
      return showArr
    },
    // 监听滚动条滚动，当滚动条滚动到底部时
    rollingLoad () {
      $(window).on(
        'scroll',
        debounce(() => {
          let wt = document.documentElement.scrollTop || document.body.scrollTop
          let dh =
            document.documentElement.scrollHeight || document.body.scrollHeight
          let wh =
            window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight
          let lh = this.$refs.loadingV2
            ? this.$refs.loadingV2.$el.clientHeight
            : 50
          // 到达底部
          this.atBottom = wt + wh >= dh - lh
          if (wt >= this.scrollTop) {
            this.rollUp = true
          } else {
            this.rollUp = false
          }
          this.scrollTop = wt
        }, 10)
      )
    }
  },
  components: {
    LoadingV2
  }
}
